export const countOccurrences = (string: string, word: string) => {
  const regex = new RegExp(word, 'gi');
  const matches = string.match(regex);
  return matches ? matches.length : 0;
};
